module.exports = __webpack_public_path__ + "media/components/country-flag/static/jo-a9f065813db62f39f45f8f6e8bc5764c.svg";